import _get from 'lodash/get'
import queryString from 'query-string'

export const hasDOM = typeof window !== 'undefined'

export const SCREEN_SIZES = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'dektop',
}

export const getScreenSize = () => {
  if (!hasDOM) {
    return null
  }
  const width = window.innerWidth
  if (width <= 520) {
    return SCREEN_SIZES.mobile
  }
  if (width <= 820) {
    return SCREEN_SIZES.tablet
  }

  return SCREEN_SIZES.desktop
}

export const getReturnUrl = () => {
  if (!hasDOM) {
    return null
  }

  const decoded = decodeURIComponent(
    window.location.search + window.location.hash
  )
  return _get(queryString.parse(decoded), 'ReturnUrl')
}
